/* global $ */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import * as XLSX from "xlsx";
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../axiosInstance';

function Addfinance() {
    const navigate = useNavigate();
    const location = useLocation();
    const existingData = location.state?.row;
    const [newRecord, setNewRecord] = useState({
        id: "",
        hp_number: "",
        reg_no: "",
        model: "",
        make_year: "",
        color: "",
        chase_no: "",
        engine_no: "",
        date: "",
        description: "",
        loan_amount: "",
        emi_amount: "",
        principal_amount: "",
        interest_amount: "",
        tenure_months: "",
        document_charges: '',
        interest_rate: "",
        loan_remark: "",
        borrower_name: "",
        borrower_address1: "",
        borrower_address2: "",
        borrower_address3: "",
        borrower_city: "",
        landmark: "",
        borrower_phone1: "",
        borrower_phone2: "",
        guarantor_name: "",
        guarantor_address1: "",
        guarantor_address2: "",
        guarantor_address3: "",
        guarantor_city: "",
        guarantor_phone1: "",
        guarantor_phone2: "",
        father_name: "",
        spouse_name: "",
        dob: "",
        house_type: "",
        profession: "",
        office_address1: "",
        office_address2: "",
        office_address3: "",
        office_city: "",
        office_phone1: "",
        due_date: "",
        penalty_perday: "",
        isfinance: "",
    });

    const [errors, setErrors] = useState({
        reg_no: "",
        loan_amount: "",
        tenure_months: "",
        interest_rate: "",
        borrower_name: "",
        borrower_address1: "",
        guarantor_name: "",
        guarantor_address1: "",
        borrower_phone1: "",
        guarantor_phone1: "",
    });
    const [registrations, setRegistrations] = useState([]);

    useEffect(() => {
        if (!existingData) {
            axiosInstance.get('/finance/next-hp-number')
                .then(res => setNewRecord(prev => ({ ...prev, hp_number: res.data?.hp_number || '' })))
                .catch(() => {});
        }
    }, [existingData]);

    useEffect(() => {
        const formatDateForInput = (dateString) => {
            if (!dateString) return "";
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return "";
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        const fetchRegistrationData = async () => {
            try {
                const endpoint = existingData
                    ? '/dealer/listforbilling'
                    : '/dealer/listforfinance';

                const response = await axiosInstance.get(endpoint);

                let fetchedList = Array.isArray(response.data?.data)
                    ? response.data.data
                    : [];

                if (existingData) {
                    console.log("Existing Data: ", existingData);

                    const formattedDate = formatDateForInput(existingData.date);
                    const formattedDob = formatDateForInput(existingData.dob);

                    console.log("Formatted date: ", formattedDate);
                    console.log("Formatted dob: ", formattedDob);

                    setNewRecord({
                        ...existingData,
                        date: formattedDate,
                        dob: formattedDob,
                    });

                    // Ensure selected reg_no is present in the list
                    const alreadyExists = fetchedList.some(
                        item => item.reg_no === existingData.reg_no
                    );

                    if (!alreadyExists) {
                        fetchedList = [
                            ...fetchedList,
                            { id: existingData.id, reg_no: existingData.reg_no }
                        ];
                    }
                }

                setRegistrations(fetchedList);
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setRegistrations([]);
            }
        };

        fetchRegistrationData();
    }, [existingData]);




    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors

        // Check if required fields are empty (if a field is required, you can add custom logic here)
        if (!newRecord.reg_no) {
            formErrors.reg_no = "Registration Number is required";
        }

        if (!newRecord.loan_amount) {
            formErrors.loan_amount = "Loan Amount is required";
        }

        if (!newRecord.tenure_months) {
            formErrors.tenure_months = "Tenure Months is required";
        }

        if (!newRecord.interest_rate) {
            formErrors.interest_rate = "Interest Rate is required";
        }

        if (!newRecord.borrower_name) {
            formErrors.borrower_name = "Borrower Name is required";
        }

        if (!newRecord.borrower_address1) {
            formErrors.borrower_address1 = "Borrower Address is required";
        }

        if (!newRecord.guarantor_name) {
            formErrors.guarantor_name = "Guarantor Name is required";
        }

        if (!newRecord.guarantor_address1) {
            formErrors.guarantor_address1 = "Guarantor Address is required";
        }

        if (!newRecord.borrower_phone1) {
            formErrors.borrower_phone1 = "Borrower Phone is required";
        }

        if (!newRecord.guarantor_phone1) {
            formErrors.guarantor_phone1 = "Guarantor Phone is required";
        }

        if (!newRecord.date) {
            formErrors.date = "Date is required";
        }

        if (!newRecord.due_date) {
            formErrors.due_date = "Due Day every Month is required";
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    // const calculateEMI = (loan_amount, interest_rate, tenure_months) => {
    //     const P = parseFloat(loan_amount);
    //     const annualRate = parseFloat(interest_rate);
    //     const N = parseInt(tenure_months);

    //     if (!P || !annualRate || !N) return "";

    //     const R = annualRate / 12 / 100;

    //     const emi = (P * R * Math.pow(1 + R, N)) / (Math.pow(1 + R, N) - 1);

    //     return emi ? emi.toFixed(2) : "";
    // };

    const calculateEMI = (loan_amount, rate_per_100, tenure_months) => {
        const P = parseFloat(loan_amount);
        const rate = parseFloat(rate_per_100);
        const N = parseInt(tenure_months);

        if (!P || !rate || !N) return "";

        // Monthly interest using vati kannuku method
        const interestPerMonth = (P / 100) * rate;
        const principalPerMonth = P / N;
        const totalEMIPerMonth = principalPerMonth + interestPerMonth;
        const totalRepayment = totalEMIPerMonth * N;

        return {
            principalPerMonth: Math.round(principalPerMonth),
            interestPerMonth: Math.round(interestPerMonth),
            totalEMIPerMonth: Math.round(totalEMIPerMonth),
            totalRepayment: Math.round(totalRepayment)
        };
    };

    const sanitizeNumber = (value) => {
        return value === "" ? null : value;
    };


    const handleRegSelectChange = (e) => {
        const selectedId = e.target.value;
        const selectedItem = registrations.find(item => item.id.toString() === selectedId);

        if (selectedItem) {
            setNewRecord({
                ...newRecord,
                id: selectedItem.id,
                reg_no: selectedItem.reg_no
            });
        } else {
            setNewRecord({
                ...newRecord,
                id: '',
                reg_no: ''
            });
        }
    };


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (existingData) {
            if (validateForm()) {
                setErrors({});
                try {
                    // Ask for confirmation before proceeding with the edit
                    const result = await Swal.fire({
                        title: 'Are you sure?',
                        text: "Do you want to Update the changes?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, update it!'
                    });

                    if (result.isConfirmed) {
                        const modified_by = localStorage.getItem('user_id')
                        console.log("Udatd Data Record: ", newRecord)
                        const updatedData = {
                            dealer_id: newRecord.dealer_id,
                            reg_no: newRecord.reg_no,
                            model: newRecord.model,
                            make_year: newRecord.make_year,
                            color: newRecord.color,
                            chase_no: newRecord.chase_no,
                            engine_no: newRecord.engine_no,
                            date: newRecord.date,
                            loan_amount: sanitizeNumber(newRecord.loan_amount),
                            emi_amount: sanitizeNumber(newRecord.emi_amount),
                            principal_amount: sanitizeNumber(newRecord.principal_amount),
                            interest_amount: sanitizeNumber(newRecord.interest_amount),
                            loan_remark: newRecord.loan_remark,
                            tenure_months: sanitizeNumber(newRecord.tenure_months),
                            document_charges: sanitizeNumber(newRecord.document_charges),
                            interest_rate: sanitizeNumber(newRecord.interest_rate),
                            borrower_name: newRecord.borrower_name,
                            borrower_address1: newRecord.borrower_address1,
                            borrower_address2: newRecord.borrower_address2,
                            borrower_address3: newRecord.borrower_address3,
                            borrower_city: newRecord.borrower_city,
                            landmark: newRecord.landmark,
                            borrower_phone1: newRecord.borrower_phone1,
                            borrower_phone2: newRecord.borrower_phone2,
                            guarantor_name: newRecord.guarantor_name,
                            guarantor_address1: newRecord.guarantor_address1,
                            guarantor_address2: newRecord.guarantor_address2,
                            guarantor_address3: newRecord.guarantor_address3,
                            guarantor_city: newRecord.guarantor_city,
                            guarantor_phone1: newRecord.guarantor_phone1,
                            guarantor_phone2: newRecord.guarantor_phone2,
                            description: newRecord.description,
                            father_name: newRecord.father_name,
                            spouse_name: newRecord.spouse_name,
                            dob: newRecord.dob,
                            house_type: newRecord.house_type,
                            profession: newRecord.profession,
                            office_address1: newRecord.office_address1,
                            office_address2: newRecord.office_address2,
                            office_address3: newRecord.office_address3,
                            office_city: newRecord.office_city,
                            office_phone1: newRecord.office_phone1,
                            due_date: sanitizeNumber(newRecord.due_date),
                            penalty_perday: sanitizeNumber(newRecord.penalty_perday),
                            modified_by: modified_by,
                        };

                        try {
                            await axiosInstance.put(`/finance/${existingData.id}`, updatedData, {
                                headers: {
                                    'Content-Type': 'application/json',
                                }

                            });

                            Swal.fire('Updated!', 'The Finance record has been updated.', 'success');
                            navigate('/finance');
                        } catch (error) {
                            console.error('Error updating data:', error);
                            Swal.fire('Error!', 'There was an issue in updating the finance record.', 'error');
                        }
                    }
                } catch (error) {
                    setErrors((prev) => ({ ...prev, form: error.message }));
                }
            }
        } else {
            const created_by = localStorage.getItem('user_id')
            if (validateForm()) {
                // Proceed with form submission (API call or other actions)
                console.log("Form submitted", newRecord);
                const newRecordData = {
                    dealer_id: newRecord.id,
                    reg_no: newRecord.reg_no,
                    model: newRecord.model,
                    make_year: newRecord.make_year,
                    color: newRecord.color,
                    chase_no: newRecord.chase_no,
                    engine_no: newRecord.engine_no,
                    date: newRecord.date,
                    loan_amount: sanitizeNumber(newRecord.loan_amount),
                    emi_amount: sanitizeNumber(newRecord.emi_amount),
                    principal_amount: sanitizeNumber(newRecord.principal_amount),
                    interest_amount: sanitizeNumber(newRecord.interest_amount),
                    tenure_months: sanitizeNumber(newRecord.tenure_months),
                    document_charges: sanitizeNumber(newRecord.document_charges),
                    interest_rate: sanitizeNumber(newRecord.interest_rate),
                    loan_remark: newRecord.loan_remark,
                    borrower_name: newRecord.borrower_name,
                    borrower_address1: newRecord.borrower_address1,
                    borrower_address2: newRecord.borrower_address2,
                    borrower_address3: newRecord.borrower_address3,
                    borrower_city: newRecord.borrower_city,
                    landmark: newRecord.landmark,
                    borrower_phone1: newRecord.borrower_phone1,
                    borrower_phone2: newRecord.borrower_phone2,
                    guarantor_name: newRecord.guarantor_name,
                    guarantor_address1: newRecord.guarantor_address1,
                    guarantor_address2: newRecord.guarantor_address2,
                    guarantor_address3: newRecord.guarantor_address3,
                    guarantor_city: newRecord.guarantor_city,
                    guarantor_phone1: newRecord.guarantor_phone1,
                    guarantor_phone2: newRecord.guarantor_phone2,
                    description: newRecord.description,
                    father_name: newRecord.father_name,
                    spouse_name: newRecord.spouse_name,
                    dob: newRecord.dob,
                    house_type: newRecord.house_type,
                    profession: newRecord.profession,
                    office_address1: newRecord.office_address1,
                    office_address2: newRecord.office_address2,
                    office_address3: newRecord.office_address3,
                    office_city: newRecord.office_city,
                    office_phone1: newRecord.office_phone1,
                    due_date: sanitizeNumber(newRecord.due_date),
                    penalty_perday: sanitizeNumber(newRecord.penalty_perday),
                    created_by: created_by,
                };
                console.log("Form submitted", newRecordData);
                try {
                    const response = await axiosInstance.post('/finance/', newRecordData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }

                    });


                    // Step 2: Check if POST was successful
                    if (response.status === 201) {
                        const dealerId = newRecordData.dealer_id;

                        if (dealerId) {
                            // Step 3: Update dealer finance flag
                            const updateResponse = await axiosInstance.put(`/dealer/isfinance/${dealerId}`, {}, {
                                headers: {
                                    'Content-Type': 'application/json',
                                }
                            });

                            console.log("Dealer updated:", updateResponse.data.message);
                        } else {
                            console.warn("Dealer ID not found in record data.");
                        }
                    }


                    setNewRecord({
                        id: "",
                        reg_no: "",
                        model: "",
                        make_year: "",
                        color: "",
                        chase_no: "",
                        engine_no: "",
                        date: "",
                        description: "",
                        loan_amount: "",
                        emi_amount: "",
                        principal_amount: "",
                        interest_amount: "",
                        tenure_months: "",
                        document_charges: "",
                        interest_rate: "",
                        loan_remark: "",
                        borrower_name: "",
                        borrower_address1: "",
                        borrower_address2: "",
                        borrower_address3: "",
                        borrower_city: "",
                        landmark: "",
                        borrower_phone1: "",
                        borrower_phone2: "",
                        guarantor_name: "",
                        guarantor_address1: "",
                        guarantor_address2: "",
                        guarantor_address3: "",
                        guarantor_city: "",
                        guarantor_phone1: "",
                        guarantor_phone2: "",
                        father_name: "",
                        spouse_name: "",
                        dob: "",
                        house_type: "",
                        profession: "",
                        office_address1: "",
                        office_address2: "",
                        office_address3: "",
                        office_city: "",
                        office_phone1: "",
                        due_date: "",
                        penalty_perday: "",
                    });

                    await Swal.fire('Created!', 'The Finance record has been Created.', 'success');
                    navigate('/finance');
                } catch (error) {
                    console.error('Error creating new finance record:', error);
                    const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
                    Swal.fire('Error!', `There was an issue creating the finance record: ${errorMessage}`, 'error');
                }
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "reg_no") {
            console.log("Selected reg_no:", value);
            console.log("Registrations list:", registrations);
            // Find selected vehicle from full registrations list
            const selected = registrations.find(item => item.reg_no === value);
            //alert(`Selected: ${JSON.stringify(selected)}`);
            console.log("Matched Data:", selected)

            setNewRecord(prev => ({
                ...prev,
                id: selected?.id || "",
                reg_no: value,
                model: selected?.model || "",
                make_year: selected?.make_year || "",
                color: selected?.color || "",
                chase_no: selected?.chase_no || "",
                engine_no: selected?.engine_no || ""
            }));
        } else {
            const updatedRecord = {
                ...newRecord,
                [name]: value
            };

            // If one of the loan-related fields changes, recalculate EMI
            if (
                name === "loan_amount" ||
                name === "interest_rate" ||
                name === "tenure_months"
            ) {
                const emi = calculateEMI(
                    updatedRecord.loan_amount,
                    updatedRecord.interest_rate,
                    updatedRecord.tenure_months
                );
                updatedRecord.emi_amount = emi.totalEMIPerMonth;
                updatedRecord.principal_amount = emi.principalPerMonth;
                updatedRecord.interest_amount = emi.interestPerMonth;
            }

            setNewRecord(updatedRecord);
        }
    };
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{existingData ? "Edit Finance" : "Add Finance"}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/finance">Finance</a></li>
                                <li className="breadcrumb-item active">
                                    {existingData ? "Edit Finance" : "Add Finance"}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2 mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                {newRecord.hp_number && (
                                    <div className="alert alert-info mb-3 py-2">
                                        <strong><i className="fas fa-hashtag mr-1"></i>HP / Loan No:</strong> {newRecord.hp_number}
                                    </div>
                                )}
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Registration No</label>
                                            <select
                                                id="reg_no"
                                                name="reg_no"
                                                className="form-control select2"
                                                value={newRecord.reg_no}
                                                onChange={handleInputChange}
                                                disabled={!!existingData} // disable when editing
                                            >
                                                <option value="">Select a Registration No</option>
                                                {registrations.map(item => (
                                                    <option key={item.id} value={item.reg_no}>
                                                        {item.reg_no}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.reg_no && <small className="text-danger">{errors.reg_no}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Model</label>
                                            <input type="text" id="model" name="model" value={newRecord.model} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Make Year</label>
                                            <input type="text" name="make_year" value={newRecord.make_year} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Color</label>
                                            <input type="text" name="color" value={newRecord.color} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Chassis Number</label>
                                            <input type="text" name="chase_no" value={newRecord.chase_no} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Engine Number</label>
                                            <input type="text" name="engine_no" value={newRecord.engine_no} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                </div>

                                <hr class="divider"></hr>

                                <label for="loan">Loan Details:</label>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Date</label>
                                            <div className="input-group" id="date" data-target-input="nearest">
                                                <input
                                                    id="date"
                                                    type="date"
                                                    value={newRecord.date || ''}
                                                    onChange={(e) => setNewRecord(prev => ({ ...prev, date: e.target.value }))}
                                                    className="form-control"
                                                    data-target="#date"
                                                />
                                            </div>
                                            {errors.date && <small className="text-danger">{errors.date}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Loan Amount</label>
                                            <input type="text" name="loan_amount" value={newRecord.loan_amount} onChange={handleInputChange} className="form-control" />
                                            {errors.loan_amount && <small className="text-danger">{errors.loan_amount}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Interest Rate</label>
                                            <input type="text" name="interest_rate" value={newRecord.interest_rate} onChange={handleInputChange} className="form-control" />
                                            {errors.interest_rate && <small className="text-danger">{errors.interest_rate}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Tenure Months</label>
                                            <input type="text" name="tenure_months" value={newRecord.tenure_months} onChange={handleInputChange} className="form-control" />
                                            {errors.tenure_months && <small className="text-danger">{errors.tenure_months}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>EMI Amount</label>
                                            <input type="text" name="emi_amount" value={newRecord.emi_amount} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Principal Per Month</label>
                                            <input type="text" name="principal_amount" value={newRecord.principal_amount} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Interest Per Month</label>
                                            <input type="text" name="interest_amount" value={newRecord.interest_amount} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Due Date Everymonth</label>
                                            <input type="text" name="due_date" value={newRecord.due_date} onChange={handleInputChange} className="form-control" />
                                            {errors.due_date && <small className="text-danger">{errors.due_date}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Penalty Per Day</label>
                                            <input type="text" name="penalty_perday" value={newRecord.penalty_perday} onChange={handleInputChange} className="form-control" />
                                            {errors.penalty_perday && <small className="text-danger">{errors.penalty_perday}</small>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Document Charges</label>
                                            <input type="text" name="document_charges" value={newRecord.document_charges} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Remark</label>
                                            <input type="text" name="loan_remark" value={newRecord.loan_remark} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>

                                <hr class="divider"></hr>

                                <label for="borrower">Borrower Details:</label>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower Name</label>
                                            <input type="text" name="borrower_name" value={newRecord.borrower_name} onChange={handleInputChange} className="form-control" />
                                            {errors.borrower_name && <small className="text-danger">{errors.borrower_name}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower Address1</label>
                                            <input type="text" name="borrower_address1" value={newRecord.borrower_address1} onChange={handleInputChange} className="form-control" />
                                            {errors.borrower_address1 && <small className="text-danger">{errors.borrower_address1}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower Address2</label>
                                            <input type="text" name="borrower_address2" value={newRecord.borrower_address2} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower Address3</label>
                                            <input type="text" name="borrower_address3" value={newRecord.borrower_address3} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower City</label>
                                            <input type="text" name="borrower_city" value={newRecord.borrower_city} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Landmark</label>
                                            <input type="text" name="landmark" value={newRecord.landmark} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower Primary Phone</label>
                                            <input type="text" name="borrower_phone1" value={newRecord.borrower_phone1} onChange={handleInputChange} className="form-control" />
                                            {errors.borrower_phone1 && <small className="text-danger">{errors.borrower_phone1}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Borrower Secondary Phone</label>
                                            <input type="text" name="borrower_phone2" value={newRecord.borrower_phone2} onChange={handleInputChange} className="form-control" />
                                            {errors.borrower_phone2 && <small className="text-danger">{errors.borrower_phone2}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Date Of Birth</label>
                                            <div className="input-group" id="dob" data-target-input="nearest">
                                                <input
                                                    id="dob"
                                                    type="date"
                                                    value={newRecord.dob || ''}
                                                    onChange={(e) => setNewRecord(prev => ({ ...prev, dob: e.target.value }))}
                                                    className="form-control"
                                                    data-target="#dob"
                                                />
                                            </div>
                                            {errors.dob && <small className="text-danger">{errors.dob}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Father Name</label>
                                            <input type="text" name="father_name" value={newRecord.father_name} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Spouse Name</label>
                                            <input type="text" name="spouse_name" value={newRecord.spouse_name} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>House Type</label>
                                            <input type="text" name="house_type" value={newRecord.house_type} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Profession</label>
                                            <input type="text" name="profession" value={newRecord.profession} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Office Address 1</label>
                                            <input type="text" name="office_address1" value={newRecord.office_address1} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Office Address 2</label>
                                            <input type="text" name="office_address2" value={newRecord.office_address2} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Office Address 3</label>
                                            <input type="text" name="office_address3" value={newRecord.office_address3} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Office City</label>
                                            <input type="text" name="office_city" value={newRecord.office_city} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Office Phone</label>
                                            <input type="text" name="office_phone1" value={newRecord.office_phone1} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>

                                <hr class="divider"></hr>

                                <label for="guarantor">Guarantor Details:</label>

                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor Name</label>
                                            <input type="text" name="guarantor_name" value={newRecord.guarantor_name} onChange={handleInputChange} className="form-control" />
                                            {errors.guarantor_name && <small className="text-danger">{errors.guarantor_name}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor Address1</label>
                                            <input type="text" name="guarantor_address1" value={newRecord.guarantor_address1} onChange={handleInputChange} className="form-control" />
                                            {errors.guarantor_address1 && <small className="text-danger">{errors.guarantor_address1}</small>}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor Address2</label>
                                            <input type="text" name="guarantor_address2" value={newRecord.guarantor_address2} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor Address3</label>
                                            <input type="text" name="guarantor_address3" value={newRecord.guarantor_address3} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor City</label>
                                            <input type="text" name="guarantor_city" value={newRecord.guarantor_city} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor Primary Phone</label>
                                            <input type="text" name="guarantor_phone1" value={newRecord.guarantor_phone1} onChange={handleInputChange} className="form-control" />
                                            {errors.guarantor_phone1 && <small className="text-danger">{errors.guarantor_phone1}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Guarantor Secondary Phone</label>
                                            <input type="text" name="guarantor_phone2" value={newRecord.guarantor_phone2} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Description</label>
                                            <textarea
                                                name="description"
                                                value={newRecord.description}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                rows="3"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer justify-content-between">
                                    <button type="submit" className="btn btn-primary">
                                        {existingData ? "Update Finance" : "Save Finance"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Addfinance